export default __webpack_public_path__ + "static/media/error.53c20311.svg";